/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher PPI means individual pixels are harder to see.`)
};

const es_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPI mayor significa que los píxeles individuales son más difíciles de distinguir.`)
};

const de_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein höherer PPI-Wert bedeutet, dass einzelne Pixel schwerer zu erkennen sind.`)
};

const nl_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een hogere PPI betekent dat losse pixels moeilijker te zien zijn.`)
};

const fr_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPP plus élevé signifie que les pixels individuels sont plus difficiles à distinguer.`)
};

const it_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un PPI più alto rende i singoli pixel più difficili da distinguere.`)
};

const pt_br2_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um PPI maior significa que os pixels individuais ficam mais difíceis de enxergar.`)
};

const pt_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um PPI mais alto torna os pixels individuais mais difíceis de ver.`)
};

const ja_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPIが高いほど個々のピクセルが見えにくくなります。`)
};

const zh_ppi_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI 越高，单个像素就越难被肉眼察觉。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_ex3", locale)
	if (locale === "en") return en_ppi_ex3(inputs)
	if (locale === "es") return es_ppi_ex3(inputs)
	if (locale === "de") return de_ppi_ex3(inputs)
	if (locale === "nl") return nl_ppi_ex3(inputs)
	if (locale === "fr") return fr_ppi_ex3(inputs)
	if (locale === "it") return it_ppi_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_ex3(inputs)
	if (locale === "pt") return pt_ppi_ex3(inputs)
	if (locale === "ja") return ja_ppi_ex3(inputs)
	return zh_ppi_ex3(inputs)
};